import type { CityConfig } from "../city-template/types";

export const coloradoSpringsConfig: CityConfig = {
  city: "Colorado Springs",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "colorado-springs",
  route: "/cities/colorado-springs",
  title: "Emergency Passport Colorado Springs, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Colorado Springs, CO — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for El Paso County and southern Colorado travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Colorado Springs, CO",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Colorado Springs and southern Colorado travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Colorado%20Springs%20cityscape%20with%20Pikes%20Peak%20mountain%20in%20the%20background%2C%20Garden%20of%20the%20Gods%20red%20rock%20formations%20visible%2C%20warm%20golden%20hour%20light%2C%20modern%20downtown%20buildings%20with%20mountain%20backdrop%2C%20clean%20and%20scenic%20urban%20view%2C%20professional%20landscape%20photography%2C%20warm%20amber%20tones%20with%20cool%20mountain%20blues%2C%20no%20visible%20text%20or%20people%2C%20cinematic%20wide%20angle%20view&width=1800&height=700&seq=csprings-hero-001&orientation=landscape",
  heroImageAlt: "Colorado Springs skyline with Pikes Peak and Garden of the Gods in the background",
  geoPosition: "38.8339;-104.8214",
  geoPlacename: "Colorado Springs, Colorado",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 70 miles — about 1 hour via I-25",
  },
  nearbyCitiesZips: [
    { name: "Downtown Colorado Springs", zips: "80903–80905" },
    { name: "Old Colorado City", zips: "80904" },
    { name: "Manitou Springs", zips: "80829" },
    { name: "Broadmoor", zips: "80906" },
    { name: "Briargate", zips: "80920" },
    { name: "Powers Corridor", zips: "80915–80918" },
    { name: "Fountain", zips: "80817" },
    { name: "Woodland Park", zips: "80863" },
    { name: "Monument", zips: "80132" },
    { name: "Palmer Lake", zips: "80133" },
    { name: "Black Forest", zips: "80908" },
    { name: "Cimarron Hills", zips: "80915" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Colorado Springs departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Fast passport renewal in Denver", route: "/denver" },
    { name: "Emergency passport help in Boulder", route: "/boulder" },
    { name: "Urgent passport services in Fort Collins", route: "/fort-collins" },
    { name: "Same-day passport help in Pueblo", route: "/colorado-springs" },
    { name: "Expedited passport services in Manitou Springs", route: "/colorado-springs" },
    { name: "Passport courier services in Monument", route: "/colorado-springs" },
    { name: "Rush passport help in Fountain", route: "/colorado-springs" },
  ],
  fpcOfficeAddress: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
  fpcOfficeNote: "Fast Passport Center serves Colorado Springs remotely via secure courier. We do not have a walk-in office in Colorado Springs — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Colorado Springs travelers.",
  fpcOfficeDistance: "Serving all of El Paso County and southern Colorado",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout the entire Colorado Springs metro area and southern Colorado. From downtown to the foothills, from the military installations to the resort communities — we help Colorado Springs travelers get their passports fast, often in 24–48 hours through our registered courier service.",
  nearbyCitiesIntro: "We serve all Colorado Springs neighborhoods and nearby communities including Manitou Springs, Fountain, Woodland Park, Monument, and Palmer Lake. If you are in El Paso County or southern Colorado, we have you covered.",
  howItWorksIntro: "Most Colorado Springs travelers complete everything online and ship documents overnight. No need to drive to Denver or wait in line at the regional agency. Our emergency and expedited passport process is designed for Colorado Springs travelers who need fast, reliable results.",
  mistakesIntro: "With Colorado Springs Airport and military families traveling internationally, Colorado Springs travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Colorado Springs travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Colorado Springs? Here are the most common ones we hear from southern Colorado travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Colorado Vital Records (Birth, Death, Marriage)", href: "https://cdphe.colorado.gov/certificates-and-records" },
    { label: "El Paso County Clerk & Recorder", href: "https://clerkandrecorder.elpasoco.com/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Colorado Springs international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Sgt. James R.",
      location: "Fort Carson, CO",
      rating: 5,
      text: "Got emergency deployment orders and needed a passport update in 48 hours. Fast Passport Center delivered exactly that. Military families need this service.",
      service: "Emergency Passport",
    },
    {
      name: "Amanda P.",
      location: "Briargate, Colorado Springs",
      rating: 5,
      text: "Needed to renew for a family trip to Germany. The process was smooth, they reviewed my documents, and I had my passport in 5 days.",
      service: "Passport Renewal",
    },
    {
      name: "Mark D.",
      location: "Manitou Springs, CO",
      rating: 5,
      text: "Lost my passport the week before my trip to Japan. They walked me through the DS-64 process and got me a replacement in 2 days. Amazing.",
      service: "Lost Passport",
    },
    {
      name: "Lt. Col. Sarah W.",
      location: "U.S. Air Force Academy, CO",
      rating: 5,
      text: "As a frequent international traveler for military assignments, I can't afford delays. Fast Passport Center has been reliable every single time.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "cs-1",
      name: "Colorado Springs Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 E. Pikes Peak Ave",
      city: "Colorado Springs",
      state: "CO",
      zip: "80903",
      phone: "(719) 635-7400",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.2 miles from downtown Colorado Springs",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Acceptance hours are limited. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "cs-2",
      name: "Briargate Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5955 Corporate Dr",
      city: "Colorado Springs",
      state: "CO",
      zip: "80919",
      phone: "(719) 598-8812",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "2.0 miles from Briargate shopping area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Busy location — book appointments 2+ weeks in advance. Limited weekend hours.",
      icon: "ri-mail-line",
    },
    {
      id: "cs-3",
      name: "Powers Corridor Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8585 Criterion Dr",
      city: "Colorado Springs",
      state: "CO",
      zip: "80920",
      phone: "(719) 597-0494",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "1.5 miles from Powers Center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular location for east Colorado Springs residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "cs-4",
      name: "Fountain Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "651 Main St",
      city: "Fountain",
      state: "CO",
      zip: "80817",
      phone: "(719) 382-5053",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from downtown Fountain",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Accepts walk-ins but appointments preferred. Photo services available on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "cs-5",
      name: "Monument Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "313 3rd St",
      city: "Monument",
      state: "CO",
      zip: "80132",
      phone: "(719) 481-2446",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from Monument Town Hall",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for north El Paso County residents. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "cs-6",
      name: "El Paso County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "1675 W. Garden of the Gods Rd",
      city: "Colorado Springs",
      state: "CO",
      zip: "80907",
      phone: "(719) 520-6200",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "3 miles from downtown Colorado Springs",
      website: "https://www.elpasoco.com/",
      websiteLabel: "El Paso County Clerk",
      notes: "Major county facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — call NPIC, limited slots. No walk-ins accepted.", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 70 miles to Colorado Passport Agency via I-25", fpc: "Ship overnight from Colorado Springs — no drive needed" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Colorado Springs-Specific Guidance", agency: "Generic — no Pikes Peak region or military community expertise", fpc: "Full Colorado Springs/Fort Carson/military/southern Colorado knowledge built in" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Colorado Springs photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Colorado Springs acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Colorado Springs applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Denver regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Colorado Springs families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Colorado Springs travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Colorado Springs." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Colorado Springs address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Colorado Springs?",
      a: "Fast Passport Center offers emergency passport processing in Colorado Springs in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, bypassing standard mail delays. This is the fastest reliable option for Colorado Springs travelers with urgent international flights.",
    },
    {
      q: "Can I get a same-day passport in Colorado Springs?",
      a: "Same-day passports are not available in Colorado Springs. The closest regional passport agency is in Denver (70 miles north). For urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option available to Colorado Springs residents without making the drive to Denver.",
    },
    {
      q: "Where can I get a fast passport renewal in Colorado Springs?",
      a: "Fast Passport Center offers fast passport renewal in Colorado Springs with no office visit required. We serve all neighborhoods including Briargate, Broadmoor, Old Colorado City, and beyond. Simply complete your application online, ship your documents using our prepaid overnight label, and our couriers handle the rest.",
    },
    {
      q: "What is the fastest way to get an urgent passport in Colorado Springs?",
      a: "The fastest way to get an urgent passport in Colorado Springs is through Fast Passport Center's emergency courier service. Our registered couriers deliver your documents directly to State Department processing facilities, achieving 24–48 hour turnaround. This is significantly faster than standard mail processing (8–11 weeks) or even government expedited mail (3–5 weeks).",
    },
    {
      q: "How fast can I get a passport in Colorado Springs?",
      a: "With Fast Passport Center's emergency courier service, Colorado Springs travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays.",
    },
    {
      q: "Do I need to drive to the Colorado Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight from Colorado Springs. Our couriers handle the in-person delivery to State Department facilities. No need to make the 70-mile drive to Denver.",
    },
    {
      q: "Where are the closest passport acceptance facilities in Colorado Springs?",
      a: "Popular options include the Colorado Springs Main Post Office (80903), Briargate Post Office (80919), Powers Corridor Post Office (80920), and El Paso County Clerk (80907). All require appointments. We help you find the most convenient location and schedule your visit.",
    },
    {
      q: "What if I live in a nearby town like Fountain or Woodland Park?",
      a: "We serve all of El Paso County and surrounding communities including Fountain, Woodland Park, Monument, and Palmer Lake. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed.",
    },
    {
      q: "How much does expedited passport service cost in Colorado Springs?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline.",
    },
    {
      q: "Do you help with passport photos in Colorado Springs?",
      a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx locations in Colorado Springs offer passport photo services. We review your photos before submission to ensure they meet State Department standards.",
    },
    {
      q: "What documents do I need for a first-time passport in Colorado Springs?",
      a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk.",
    },
    {
      q: "Can you help with a child's passport in Colorado Springs?",
      a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Colorado Springs families through the entire process and help schedule acceptance clerk appointments.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Briargate", address: "5910 Stetson Hills Blvd, Colorado Springs, CO 80923", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Downtown", address: "102 N. Tejon St, Colorado Springs, CO 80903", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/photo" },
    { name: "FedEx Office — Powers", address: "5845 Mark Dabling Blvd, Colorado Springs, CO 80919", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com/" },
    { name: "UPS Store — Broadmoor", address: "1825 E. Cheyenne Mountain Blvd, Colorado Springs, CO 80906", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart — Fountain", address: "6310 S. Hwy 85/87, Fountain, CO 80817", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/photo" },
    { name: "Rite Aid — Manitou Springs", address: "807 Manitou Ave, Manitou Springs, CO 80829", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/photo" },
    { name: "Postal Annex — Monument", address: "251 Front St, Monument, CO 80132", hours: "Mon–Fri: 9AM–6PM, Sat: 9AM–4PM", website: "https://www.postalannex.com/" },
    { name: "Costco — Colorado Springs", address: "5050 N. Nevada Ave, Colorado Springs, CO 80918", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM", website: "https://www.costco.com/photo" },
  ],
  dmvLocations: [
    {
      name: "DMV — Colorado Springs",
      address: "2447 E. La Salle St, Colorado Springs, CO 80909",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and driver's license renewals. Appointment required.",
      featured: true,
    },
    {
      name: "DMV — Powers",
      address: "5650 Industrial Pl, Colorado Springs, CO 80916",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Passport-ready photo services available. Online appointment booking.",
      featured: false,
    },
    {
      name: "DMV — Fountain",
      address: "6945 Mesa Ridge Pkwy, Fountain, CO 80817",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID processing. Walk-ins limited — book online first.",
      featured: false,
    },
    {
      name: "DMV — Woodland Park",
      address: "801 W. Midland Ave, Woodland Park, CO 80863",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Full-service center for Teller County. Extended hours available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "COS",
      name: "Colorado Springs Airport",
      distance: "10 miles from downtown Colorado Springs",
      address: "7770 Milton E. Proby Pkwy, Colorado Springs, CO 80916",
      note: "The primary airport for southern Colorado. Domestic flights with connections to major international hubs.",
      flightUrl: "https://www.coloradosprings.gov/airport",
      flightLabel: "COS Flight Info",
      featured: true,
    },
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "70 miles from Colorado Springs",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Major international hub for Colorado. Many Colorado Springs travelers use DEN for international flights.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "Denver International Airport",
      featured: false,
    },
  ],
};